import * as React from 'react';

import {
  WritebackContext,
  UPDATE_QUESTION,
} from 'src/components/writeback/writeback-wrapper';
import {StringListInput} from 'src/components/lib/token-list-input//index';

import moduleCss from 'src/components/workflow/event/content/module/editors/module.css';


export default ({
  conditionalAlerts,
}: {
  conditionalAlerts?: boolean;
}): React.ReactElement<React.ComponentProps<'div'>> => {
  const {state, dispatch} = React.useContext(WritebackContext);
  const currentQuestionType = state.question?.selectedType;
  // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'QuestionType' can't be used to index type 'CurrentQuestion'.
  const currentQuestion = state.question?.[currentQuestionType];
  return (
    <div className={moduleCss.generalModule_row}>
      {conditionalAlerts && (
        <label className={moduleCss.generalModule_alertKeywordsLabel}>
          <div className={moduleCss.rowLabel}>
            Send alert when keywords detected:
          </div>
          <StringListInput
            // @ts-expect-error - TS2322 - Type '{ verticalStretch: true; placeholder: string; values: any; onChange: (alertKeywords: string[]) => void; }' is not assignable to type 'IntrinsicAttributes & { values: string[]; options: string[]; onChange: (values: string[]) => void; }'.
            verticalStretch
            placeholder="e.g. bad, late, inexperienced"
            values={currentQuestion.alertKeywords || []}
            onChange={(alertKeywords) =>
              dispatch({
                type: UPDATE_QUESTION,
                payload: {
                  questionType: currentQuestionType,
                  // @ts-expect-error - TS2322 - Type '{ alertKeywords: string[]; }' is not assignable to type 'Question'.
                  attrs: {
                    alertKeywords,
                  },
                },
              })
            }
          />
        </label>
      )}
    </div>
  );
};
